import React from "react";
import injectSheet from "react-jss";
import loaderStyles from "./fieldLoader.style";
import ToggleDisplay from "Common/ToggleDisplay";
import LoadingImage from 'Common/Images/blueLoading.gif';

const FieldLoader = ({ isLoading, classes }) => (
  <ToggleDisplay if={isLoading}>
    <div className={classes.loading}>
      <img className={classes.img} alt="loading" src={LoadingImage} />
    </div>
  </ToggleDisplay>
);

export default injectSheet(loaderStyles)(FieldLoader);



// WEBPACK FOOTER //
// ./src/components/Common/Loader/FieldLoader/FieldLoader.js